import Request from "../../lib/request";
import {
  PROJECT_USERS_API,
  REPORTS_API,
  VAT_REVIEW_API
} from "../../constants/api";
import { PAGE } from "../../constants/filters";
import { PROJECT_USER_ID } from "../../constants/storageKeys";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const getList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${VAT_REVIEW_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
